<template>
	<b-modal
		scrollable
		no-fade
		ok-only
		:ok-title="$t('AssignConfirmation.oktitle')"
		:title="$t('AssignConfirmation.title')"
		static
		id="modal-assign-confirmation-view"
		size="md"
		body-class="position-static"
		@ok="onSubmit"
	>
		<b-row>
			<div class="col-12 mb-3 text-center">
				<p class="mb-0 text-info">{{ rowsMessage }}</p>
			</div>
			<b-form-group
				class="col-12"
				:label="$t('global.selectOption')"
			>
				<b-form-select
					size="sm"
					v-model="confirmation"
					:options="options"
					required
				/>
			</b-form-group>
		</b-row>
	</b-modal>
</template>

<script>
export default {
	methods: {
		onSubmit(event) {
			event.preventDefault();
			if (this.confirmation == null) {
				this.$root.showAlert(this.$t("bookings.emptyStateSelect"), {
					variant: "warning"
				});
				return;
			}
			if (!this.selected.length >0) {
				this.$root.showAlert(this.$t("bookings.selectServiceMassive"), {
					variant: "warning"
				});
				return;
			}

			this.$bvModal
					.msgBoxConfirm(this.messageConfirmationAction, {
						title: ' ',
						size: "sm",
						buttonSize: "sm",
						okVariant: "success",
						okTitle: this.$t("global.yes"),
						cancelTitle: "No",
						footerClass: "p-2",
						hideHeaderClose: false,
						centered: true
					})
					.then(value => {
						if (value === true) {
							let aux = {
								ids: this.itemValid,
								confirmation: this.confirmation
							};
							this.$root.api
							.post(`/transport-services/massive-update-confirmation`, aux)
							.then(() => {
								// Indicar cuantos registros fueron actualizados
								if (this.itemValid.length < this.selected.length) {
									this.$root.showAlert(
										this.$t("bookings.asignMsgPartial").replace(
											"$TOTAL",
											this.selected.length - this.itemValid.length
										),{variant:"warning"}
									);
								} else {
									this.$root.showAlert(this.$t("bookings.asignMsg"));
								}
								this.$root.$emit(
									"bv::refresh::table",
									"reservations-index-list"
								);
								this.$emit("cleanIndices");
							})
							.catch(err => {
								this.$root.handleRequestError(err);
							});
						}
					})
					.catch(err => {
						console.log(err);
						// An error occurred
					});
		}
	},
	props: {
		selected: {
			type: Array,
			required: true
		},
		itemValid: {
			type: Array,
			required: false
		}
	},
	components: {},
	data() {
		return {
			confirmation: null
		};
	},
	computed: {
		options: function() {
			const optios = [];
			const elm = this.$t("bookings.AcceptedOptionsMassive");
			Object.keys(elm).forEach(item => {
				optios.push({ value: item, text: elm[item] });
			});
			return optios;
		},
		rowsMessage() {
			return this.$t("AssignConfirmation.rowsMessage").replace(
				"$TOTAL",
				this.selected.length
			);
		},
		messageConfirmationAction(){
			let action = this.$t("bookings.AcceptedOptionsMassive")[this.confirmation]
			return this.$t("bookings.confirmSupplierConfirmationMassive",{action:action.toUpperCase()})
		}
	},
	mounted() {

	},
	watch: {}
};
</script>
